import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'plugins-tooltip',
  imports: [],
  template: `{{ text() }}`,
  // eslint-disable-next-line @angular-eslint/component-max-inline-declarations
  styles: `
    :host {
      position: relative;
      display: inline-block;
      max-width: 12rem;
      padding: 0.5rem;
      color: #ffffff;
      background: #000000;
      border-radius: 0.25rem;
      pointer-events: none;

      &::after {
        content: '';
        display: block;
        position: absolute;
        border: 6px solid transparent;
      }
    }

    ::ng-deep .cdk-overlay-pane.tooltip {
      pointer-events: none;

      &.left plugins-tooltip {
        margin-right: 8px;

        &::after {
          top: 50%;
          right: 0;
          border-left-color: #000000;
          transform: translate(100%, -50%);
        }
      }

      &.right plugins-tooltip {
        margin-left: 8px;

        &::after {
          top: 50%;
          left: 0;
          border-right-color: #000000;
          transform: translate(-100%, -50%);
        }
      }

      &.top plugins-tooltip {
        margin-bottom: 8px;

        &::after {
          bottom: 0;
          left: 50%;
          border-top-color: #000000;
          transform: translate(-50%, 100%);
        }
      }

      &.bottom plugins-tooltip {
        margin-top: 8px;

        &::after {
          top: 0;
          left: 50%;
          border-bottom-color: #000000;
          transform: translate(-50%, -100%);
        }
      }
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TooltipComponent {
  readonly text = input.required<string>();
}
